import React, { useEffect } from "react";
import { PopsController } from "../../classes/popsController"
import { defPath } from "../../config/defPath";
import { useSession } from "../../hooks/useState";

window.dataLayer = window.dataLayer || [];

export default function Popup() {
	const { logged } = useSession(state => state)

	const handleClose = () => {
		// @ts-ignore
		window.soundController && window.soundController.play('cerrar', false, 1)
		if (window.redeem) {
			window.dataLayer.push({
				'event': 'GAEvent',
				'event_category': 'Content',
				'event_action': 'Button',
				'event_label': `${window.redeem} - Redeem Coins`,
				'interaction':'true',
				'component_name': 'Modo_Carrera_CoinRedemption',
				'element_text': 'Cerrar',
			});
			window.redeem = undefined
		}
		const popup = new PopsController
		popup.close()
	}

	return (
		<>
			<section className="ar__popup_overlay">
				<div className="newHeaderTopLogos">
					<div className="newHeaderTopLogos__olas">
						<img className="ola1" src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} alt="Imagen olas" />
						<img className="ola2" src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} alt="Imagen olas" />
					</div>
					<div className="newHeaderTopLogos__logo">
						<img src={`${defPath}/assets/images/logo_aguila_new.png`} alt="Logo Estadio Aguila" />
					</div>
					{/* <div className="newHeaderTopLogos__star">
						<img src={`${defPath}/assets/images/newHeaderTopLogos/star.png`} alt="Imagen estrellas" />
					</div> */}
				</div>
				<button className={`ar__popup--close black_30 ${logged ? 'logged': ''}`} onTouchEnd={handleClose} onClick={handleClose}>
					<span>CERRAR</span>
					<img src={`${defPath}/assets/images/icons/icon_xclose.png`} alt="icono close" />
				</button>

				<div className="ar__popup">
					<div className="ar__popup--content">
						{/* dynamic PopsController.ts */}
					</div>
				</div>

			</section>

		</>
	)
};
